import React, { Component } from 'react';
import _validator from 'modules/validator';
import _AdminService from 'modules/AdminService';
import LoadingSpinner from 'components/enterprise/LoadingSpinner';
import _notification from 'modules/notification';
import { GENERAL_ERROR_MESSAGE } from 'constants/constants';
import { Pagination } from 'antd';
import PageHeader from 'components/enterprise/PageHeader';
import { routesAdmin } from 'routes/Routes';
import Button from 'components/controls/Button';
import EmptyState from 'components/enterprise/EmptyState';

class RetryInterviewCallLetterDownloadSMS extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pagination: { pageSize: 100, current: 1, total: 0 },
            highlightedRowID: 0,
            data: [],
            rowData: {},
            loading: false,
            showMessageBox: false,
            totalRowCount: 0,
            searchTerm: "",
        };
    }

    componentDidMount() {
        this.GetStudentListForRetryInterviewCallLetterSMS();
    }

    //API operations
    GetStudentListForRetryInterviewCallLetterSMS = async () => {
        try {
            this.setState({ loading: true }, async () => {
                try {
                    let candidateListData = await _AdminService.GetStudentListForRetryInterviewCallLetterSMS();
                    let searchedData = candidateListData.data;
                    let candidateList = searchedData.Obj;
                    this.setState({
                        ...this.state,
                        data: candidateList,
                        totalRowCount: candidateList.lenght,
                        loading: false,
                    });

                } catch (e) {
                    // TODO
                    this.setState({ loading: false });
                    console.log('Error: ', e);
                }
            });
        } catch (e) {
            this.setState({ loading: false })
        }
    }

    onPageChange = (pageNumber) => {
        //console.log(pageNumber);
        this.setState({ pagination: { ...this.state.pagination, current: pageNumber }, });
        this.search();
    }


    retryInterviewCallLetterSMS = async (id) => {
        try {
            this.setState({ loading: true }, async () => {
                const response = await _AdminService.SendRetrySMSForInterviewCallLetterDownload(id);

                const data = response.data;
                if (data.IsSuccess == true) {
                    _notification.showMessage('success', "Retry Interview Call Letter SMS Send Successfully");
                    setTimeout(() => {
                        this.GetStudentListForRetryInterviewCallLetterSMS();
                    }, 1000);
                }
                else {
                    _notification.showMessage('error', GENERAL_ERROR_MESSAGE);
                    this.setState({
                        loading: false
                    })
                }
            })
        } catch (error) {
            _notification.showMessage('error', GENERAL_ERROR_MESSAGE);
        }
    }


    render() {
        return (
            <div className="containerNew  analysisWrap pt-3 pb-3">
                {this.state.loading && <LoadingSpinner/>}

                <PageHeader
                    title="Send Retry Interview Call Letter SMS"
                    breadcrumbItems={[{ label: 'Dashboard', path: routesAdmin.dashboard.path }, { label: 'Communications' }, { label: 'Send Retry Interview Call Letter SMS' }]}
                />

                <div className="containerNew analysisWrap pt-3 pb-3 p-sm-4 p-md-2 customTableDivWrapper" >
                    <table className='customTable' id="myTable">
                        <tbody>
                            <tr className='stickyDivTranColumnHeader'>
                                <th>Form #</th>
                                <th>Application ID</th>
                                <th>Name</th>
                                <th>Applied Post</th>
                                <th>Mobile Number</th>
                                <th>Action</th>
                            </tr>
                            {this.state.data.map((item, index) => (

                                <tr data-index={index} key={item.Id} className='stickyDivTranRows'>
                                    <td>{item.Form_Number}</td>
                                    <td>{item.Application_Id}</td>
                                    <td>{item.First_Name}{" "}{item.Middle_Name}{" "}{item.Last_Name} </td>
                                    <td>{item.Applied_Post}</td>
                                    <td>{item.Mobile_Number}</td>
                                    <td style={{ lineHeight: '15px' }}>
                                        <Button type="button" value="Retry" onClick={() => this.retryInterviewCallLetterSMS(item.Id)} className="button-global button-border small autoHeight" />
                                    </td>

                                </tr>
                            ))}
                        </tbody>
                    </table>
                    {!this.state.data.length ?
                        <EmptyState icon="inbox" title="No records found" />
                        : ""}
                </div>

                {this.state.data && this.state.data.length > 0 &&
                    <div style={{ display: 'flex', justifyContent: 'end', textAlign: 'center' }}>
                        <label style={{ textAlign: 'right', marginRight: '20px', paddingTop: '6px' }}>Total Records: {this.state.totalRowCount}</label>

                        <div style={{ textAlign: 'right' }}>
                            <Pagination
                                showSizeChanger
                                pageSizeOptions={['100', '200', '300', '500', '1000']}
                                onShowSizeChange={this.onShowSizeChange}
                                onChange={this.onPageChange}
                                defaultCurrent={this.state.pagination.current}
                                total={this.state.pagination.total}
                                pageSize={this.state.pagination.pageSize}
                            />
                        </div>
                    </div>
                }
            </div>)
    };
}

export default RetryInterviewCallLetterDownloadSMS;